import { FileText, HelpCircle, FileSpreadsheet, Lock, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PageRoutes } from "../pageRoutes";
import "./popMenu.scss";

const InvestorPop = ({ setInvestorPop }: any) => {
  const navigate = useNavigate();

  const handleSignup = () => {
    let Api_URL: any = "";
    const env = process.env.REACT_APP_STAGE_ENV;
    switch (env) {
      case "dev":
        Api_URL = process.env.REACT_APP_TICCA_DEV_SINUP;
        break;
      case "stage":
        Api_URL = process.env.REACT_APP_TICCA_STAGE_SINUP;
        break;
      case "prod":
        Api_URL = process.env.REACT_APP_TICCA_PRO_SINUP;
        break;
      default:
        Api_URL = process.env.REACT_APP_TICCA_DEV_SINUP;
        break;
    }

    window.location.href = Api_URL;
  };

  const handleLogin = () => {
    let Api_URL: any = "";
    const env = process.env.REACT_APP_STAGE_ENV;
    switch (env) {
      case "dev":
        Api_URL = "https://dev.login.ticca.com/?domain=dev.www.ticca.ltd";
        break;
      case "stage":
        Api_URL = "https://stage.login.ticca.com/?domain=stage.www.ticca.ltd";
        break;
      case "prod":
        Api_URL = "https://login.ticca.com/?domain=www.ticca.ltd";
        break;
      default:
        Api_URL = "https://dev.login.ticca.com/?domain=dev.www.ticca.ltd";
        break;
    }

    window.location.href = Api_URL;
  };

  const handleClose = () => {
    sessionStorage.setItem("investor_stage0_popup_dismissed", "1");
    setInvestorPop(false);
  };

  const handleStageZeroNavigation = (route: string) => {
    setInvestorPop(false);
    navigate(route);
  };

  return (
    <>
      <div className="investor-stage-popup">
        <div className="investor-stage-popup__card">
          <button
            className="investor-stage-popup__close-btn"
            type="button"
            onClick={handleClose}
            aria-label="Close"
          >
            <X size={16} />
          </button>

          <h3>More documents are available</h3>
          <p>
            Start with documents: Intro, FAQ, and Fact Sheet. Sign up
            to continue reading the full investor content.
          </p>

          <div className="investor-stage-popup__lists">
            <div className="investor-stage-popup__list investor-stage-popup__list--open">
              <h4>AVAILABLE NOW </h4>
              <button
                className="investor-stage-popup__item investor-stage-popup__item--button"
                type="button"
                onClick={() => handleStageZeroNavigation(PageRoutes.Intro)}
              >
                <FileText size={16} />
                <span>Intro</span>
              </button>
              <button
                className="investor-stage-popup__item investor-stage-popup__item--button"
                type="button"
                onClick={() => handleStageZeroNavigation(PageRoutes.faq)}
              >
                <HelpCircle size={16} />
                <span>FAQ</span>
              </button>
              <button
                className="investor-stage-popup__item investor-stage-popup__item--button"
                type="button"
                onClick={() => handleStageZeroNavigation(PageRoutes.factSheet)}
              >
                <FileSpreadsheet size={16} />
                <span>Fact Sheet</span>
              </button>
            </div>

            <div className="investor-stage-popup__list investor-stage-popup__list--locked">
              <h4>MORE DOCUMENTS (SIGN UP TO UNLOCK)</h4>
              {[
                "Business Summary",
                "Q & A",
                "AI Executive Summary",
                "Financial Projection",
                "SAFE Agreement",
                "Corporate Governance Policy",
              ].map((docName) => (
                <div key={docName} className="investor-stage-popup__item">
                  <Lock size={14} />
                  <span>{docName}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="investor-stage-popup__actions">
            <button
              onClick={handleLogin}
              className="investor-stage-popup__login-btn"
              type="button"
            >
              Log In
            </button>
            <button
              onClick={handleSignup}
              className="investor-stage-popup__signup-btn"
              type="button"
            >
              Sign Up
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvestorPop;


